import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Link,
  Text,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DocumentsQuery } from 'generated/graphql';
import { Link as RouterLink } from 'react-router-dom';
import File from './File';

type Document = NonNullable<DocumentsQuery['documents']['edges'][number]['node']>;

interface Props {
  name: string;
  documents?: Document[];
  showAddButton?: boolean;
  type?: string;
}

function Folder({ name, documents = [], showAddButton = false, type = '' }: Props) {
  const route = `documents/new?documentType=${type}`;

  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={{ bg: 'gray.100' }}>
          <Box flex="1" textAlign="left">
            {name}
            {showAddButton && !documents.length && (
              <Link ml={2} as={RouterLink} to={route}>
                <FontAwesomeIcon icon={['fal', 'plus']} />
              </Link>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        {!documents.length && <Text fontSize="sm">No documents to show</Text>}
        {documents.map(document => (
          <File key={document.id} document={document} />
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
}

export default Folder;
